import template from './affiliates.html';
import controller from './affiliates.controller';
import './affiliates.styl';

let affiliateComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default affiliateComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/affiliates/affiliates.component.js
 **/